module.exports = __webpack_public_path__ + "5d8808d43cefca6f6781a5316d176632.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/ui-icons_cd0a0a_256x240.png
// module id = 486
// module chunks = 2